export default "__VITE_ASSET__CfooQrnw__"